import React from 'react';
import './Dashboard.css';

const DEFAULT_STAGES = [
  'Preparing Deployment',
  'Provisioning Cloud Infrastructure',
  'Verifying Domain & DNS',
  'Installing Application',
  'Fetching Access Credentials',
];

const StatusTracker = ({ currentStage, errorStage, stages = DEFAULT_STAGES }) => {
  return (
    <div className="status-tracker-wrapper">
      <div className="status-tracker">
        {stages.map((stage, index) => {
          const isError = errorStage !== null && index === errorStage;
          const isDone = errorStage !== null ? index < errorStage : index < currentStage;
          const isActive = errorStage === null && index === currentStage;

          return (
            <div className="tracker-item" key={index}>
              <div className="tracker-icon-container">
                <div className={`circle ${isError ? 'error' :
                    isDone ? 'done' :
                      isActive ? 'active' : ''
                  }`}>
                  {isError ? '✖' : isDone ? '✔' : index + 1}
                </div>
                {index < stages.length - 1 && (
                  <div className={`vertical-line ${index < currentStage ? 'done' : ''}`} />
                )}
              </div>
              <div className="tracker-label">{stage}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTracker;
